<template>
  <div style="height: 100%;" v-loading="isLoading">
    <component style="height: 100%;" v-if="configComponent && configComponent !== null" :is="configComponent" :search="this.param.search" :data="analyseData" ></component>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import components from './showConfigComponents'
  export default {
    props: {
      param: {
        type: Object
      }
    },
    name: 'show-analyse',
    data() {
      return {
        analyseData: null,
        configComponent: null,
        isLoading: false
      }
    },
    mounted() {
      this.loadAnalyseData()
    },
    methods: {
      loadAnalyseData: function () {
        this.isLoading = true
        util.ajax.post('/entity/analyse/analyseConfig/analyseData', this.param).then(res => {
          if (res.data.meta && res.data.meta.errCode === 0) {
            this.analyseData = res.data.data
            this.configComponent = components[res.data.data.type]
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
          }
          this.isLoading = false
        }).catch(err => {
          console.error(err)
          this.isLoading = false
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/show-analyse.vue